<template>
  <div>
    <v-container>
      <v-form ref="form" v-model="valid">
        <h2 class="mb-2">
          {{ $store.state.customerName }} カレンダー形式 一覧画面
        </h2>
        <!-- {{ productForms.area }} -->
        <p>一覧表示する帳票を設定</p>
        <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
        <v-row>
          <v-col cols="12" sm="9">
            <v-card outlined class="pa-6">
              <v-row justify="center">
                <v-btn @click="modalOpen(2)" color="primary" class="ma-4"
                  >検索フォームの追加</v-btn
                >
                <v-btn @click="modalOpen(3)" color="primary" class="ma-4"
                  >CSVダウンロードボタンの追加</v-btn
                >
              </v-row>
              <v-row justify="center" class="mt-4">
                <v-radio-group
                  label="新規作成ボタン"
                  v-model="productForms.area[0].create"
                  row
                >
                  <v-radio label="有" v-bind:value="true"></v-radio>
                  <v-radio label="無" v-bind:value="false"></v-radio>
                </v-radio-group>
              </v-row>
              <v-text-field
                v-model="productForms.area[0].path"
                element="ul"
                label="Path"
                placeholder="クリックすると移動するURL"
                background-color="white"
                outlined
                disabled
              ></v-text-field>
              <v-text-field
                v-model="productForms.area[0].list_pageID"
                element="ul"
                label="ページID"
                placeholder="一覧表示するページID"
                background-color="white"
                outlined
                :rules="[rules.numonly]"
              ></v-text-field>
              <v-row justify="center" class="mt-4">
                <v-btn @click="modalOpen(1)" color="primary"
                  >カレンダー情報の設定</v-btn
                >
              </v-row>
              <v-row justify="center" class="mt-4">
                <v-btn @click="saveForm()" color="primary">SAVE</v-btn>
              </v-row>
              <v-dialog v-if="head_dialog" v-model="head_dialog">
                <calenderindex-form
                  v-on:clickSubmit="modalClose"
                  :values="value_t"
                ></calenderindex-form>
              </v-dialog>
              <v-dialog v-if="search_dialog" v-model="search_dialog">
                <search-form
                  v-on:clickSubmit="modalClose"
                  :searchs="productForms.searchs_t"
                ></search-form>
              </v-dialog>
              <v-dialog v-if="csv_dialog" v-model="csv_dialog">
                <csv-form
                  v-on:clickSubmit="modalClose"
                  :value="csv_t"
                  :enable="
                    productForms.area[productForms.area.length - 1].name ==
                      'csv' &&
                    productForms.area[productForms.area.length - 1].value != ''
                      ? true
                      : false
                  "
                  :page_id="Number(productForms.area[0].list_pageID)"
                ></csv-form>
              </v-dialog>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import calenderindexForm from "../../components/BuilderForm/ReportIndex/CalenderIndexForm";
import searchForm from "../../components/BuilderForm/ReportIndex/IndexSearchForm";
import csvForm from "../../components/BuilderForm/ReportIndex/IndexCsvForm";
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  components: {
    calenderindexForm,
    searchForm,
    csvForm,
  },
  data() {
    return {
      head_dialog: false,
      search_dialog: false,
      csv_dialog: false,
      productForms: {
        pageID: null,
        area: [
          {
            type: 5,
            path: null,
            list_pageID: null,
            create: false,
            value: {
              type: "month",
            },
          },
        ],
        value_t: [],
        searchs_t: [],
        delete_area: [],
      },
      csv_t: [],
      value_t: {},
      //バリデーション
      valid: true,
      rules: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
      },
    };
  },
  async mounted() {
    //初期処理
    await this.getInit();
  },
  methods: {
    async getInit() {
      //初期処理
      this.isLoading = true;
      //page IDとcustomer IDとform情報を送信
      let data = {};
      data.customerID = this.$store.state.customerID;
      data.pageID = Number(this.$route.params.page_id);
      this.productForms.pageID = this.$route.params.page_id;
      this.$store.state.customerID = Number(this.$route.params.id);
      const response = await api.GetForm(data);
      if (response.data[0][0].ID != 0) {
        this.productForms.area = this.respose_convert(response.data[0]);
      }
      //読み込み終了
      this.isLoading = false;
    },
    async saveForm() {
      if (!this.$refs.form.validate()) {
        return;
      }
      let data = {
        area: [this.productForms.area],
        pageID: this.productForms.pageID,
        delete_area: this.productForms.delete_area,
      };
      try {
        data.pageID = await api.RegForm(data, "");
        alert("保存完了");
        this.back();
      } catch (err) {
        alert("送信失敗");
        console.log(err);
      }
    },
    modalOpen: function(value) {
      if (!Number(this.productForms.area[0].list_pageID)) {
        return;
      }
      switch (value) {
        case 1:
          //参照渡しの回避
          if (this.productForms.area[0].value == null) {
            this.value_t = {};
          } else {
            if (typeof this.productForms.area[0].value === "string") {
              this.value_t = JSON.parse(this.productForms.area[0].value);
            } else {
              this.value_t = JSON.parse(
                JSON.stringify(this.productForms.area[0].value)
              );
            }
          }
          this.head_dialog = true;
          break;
        case 2:
          this.productForms.searchs_t = JSON.parse(
            JSON.stringify(this.productForms.area)
          );
          this.search_dialog = true;
          break;
        case 3:
          //末尾がCSVダウンロードボタンでない場合
          if (
            this.productForms.area[this.productForms.area.length - 1].name !=
              "csv" ||
            this.productForms.area[this.productForms.area.length - 1].value ==
              "" ||
            this.productForms.area[this.productForms.area.length - 1].value ==
              null
          ) {
            this.csv_t = [];
          } else {
            this.csv_t = JSON.parse(
              this.productForms.area[this.productForms.area.length - 1].value
            );
          }
          this.csv_dialog = true;
          break;
      }
    },
    modalClose(param) {
      //head(カレンダー情報設定)モーダル
      if (this.head_dialog) {
        this.productForms.area[0].value = JSON.stringify(param.values);
        this.value_t = null;
        this.head_dialog = false;
      } else if (this.search_dialog) {
        //serachモーダル
        this.productForms.area = param.searchs;
        this.productForms.delete_area = param.delete_area;
        this.productForms.searchs_t = null;
        this.search_dialog = false;
      } else if (this.csv_dialog) {
        //CSVモーダル
        let tmp = {};
        tmp.form_id = this.productForms.area[
          this.productForms.area.length - 1
        ].form_id;
        tmp.name = "csv";
        tmp.type = 5;
        tmp.list_pageID = this.productForms.area[0].list_pageID;
        if (!param.enable) {
          tmp.value = null;
        } else {
          tmp.value = JSON.stringify(param.value);
        }
        if (
          this.productForms.area[this.productForms.area.length - 1].name ==
          "csv"
        ) {
          this.productForms.area[this.productForms.area.length - 1] = tmp;
        } else {
          this.productForms.area.push(tmp);
        }
        this.csv_dialog = false;
      }
    },
    respose_convert: function(data) {
      let area = [];
      data.forEach((value, index) => {
        let tmp = {};
        tmp.form_id = value.ID;
        tmp.name = value.Name;
        tmp.type = 5; //value.Type;
        tmp.path = value.Label;
        tmp.list_pageID = value.Init;
        //ヘッダー
        if (index == 0) {
          tmp.value = JSON.parse(value.Value);
          if (value.Rule == "true") {
            tmp.create = true;
          } else {
            tmp.create = false;
          }
          area.unshift(tmp);
        } else if (value.Name == "") {
          //検索フォーム
          const s = value.Value.split(",");
          tmp.value = s[0];
          tmp.target_id = s[1];
          tmp.color = value.Rule;
          area.push(tmp);
        } else if (value.Name == "csv") {
          //CSVフォーム
          tmp.value = value.Value;
          area.push(tmp);
        }
      });
      return area;
    },
    back() {
      history.back();
    },
  },
};
</script>

<style lang="stylus">
.droparea {
  background: #eee;
  min-height: 30em;
  padding: 1em;
}

/* ボタンの横に×ボタンwの表示するための調整 */
.tmp {
  width: 95%;
  padding: 0.2em;
  background-color: white;
}
</style>
